import React from "react";
import { useDeleteBranchAdminMutation } from "../../../../redux/api/solar-estimation/solarEstimationAPI";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../../shared/oversight-core/utils/toast";

interface IProps extends ModelContainerProps {
  show: boolean;
  branchId: string;
  setIsUpdateCurrentState: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteBranchModal = (props: IProps) => {
  const { show, branchId, setIsUpdateCurrentState, ...rest } = props;

  const [triggerDeleteBranch, { isLoading }] = useDeleteBranchAdminMutation();

  const deleteBranch = (branchId: string) => {
    triggerDeleteBranch({ branchId })
      .unwrap()
      .then(() => {
        showSuccessMessage("Branch deleted successfully");
        rest.onClose?.();
        setIsUpdateCurrentState((prev) => !prev);
      })
      .catch(() => {
        showErrorMessage("Failed to delete branch");
      });
  };

  return (
    <ModalContainer
      {...rest}
      title={"Delete Branch"}
      show={show}
      size="modal-md"
      confirmButtonText="Delete"
      confirmButtonVariant="red"
      cancelButtonText="Cancel"
      onConfirm={() => deleteBranch(branchId)}
      isLoading={isLoading}
    >
      <>
        <p className="text-light font-weight-400 font-size-14">
          Are you sure you want to delete this branch?
        </p>
      </>
    </ModalContainer>
  );
};

export default DeleteBranchModal;
